module.exports = __webpack_public_path__ + "img/emblem.d0289dc0.png";